import { GraphCommand } from "./interfaces/config";
import React from "react";
import Plot from "react-plotly.js";
import Plotly from "plotly.js";
import memoize from "memoize-one";
import LegendFilter from "./Legend/LegendFilter";
import "./Graph3d.scss";
export class Graph3D extends React.PureComponent {
    constructor(props) {
        super(props);
        this.prepareDataTraces = memoize(this._prepareDataTraces);
        this.state = {
            filter: "",
            position: {
                x: null,
                y: null,
            },
        };
    }
    handleHideAll() {
        if (this.state.filter === undefined) {
            this.setState({ filter: "" });
        }
        else {
            this.setState({ filter: undefined });
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.reset !== this.props.reset &&
            this.props.graph.command === GraphCommand.levels) {
            Plotly.relayout("surfaces_container", {
                xaxis: {
                    autorange: true,
                },
                yaxis: {
                    autorange: true,
                },
            });
        }
        if (prevProps.reset !== this.props.reset &&
            this.props.graph.command === GraphCommand.graph3d) {
            Plotly.relayout("surfaces_container", {
                camera: {
                    up: { x: 0, y: 0, z: 1 },
                    center: { x: 0, y: 0, z: 0 },
                    eye: { x: 1.25, y: 1.25, z: 1.25 },
                },
            });
        }
        if (prevProps.dragmode !== this.props.dragmode) {
            Plotly.relayout("surfaces_container", {
                dragmode: this.props.dragmode,
            });
        }
    }
    updateCursorPosition(el) {
        if (this.props.graph.command === GraphCommand.levels) {
            this.setState({ position: { x: el.xvals[0], y: el.yvals[0] } });
        }
    }
    _prepareDataTraces(graph, dataset, xValues, yValues, zValues, showGrid, height, width) {
        let surfacesData = [];
        let layout;
        switch (graph.command) {
            case GraphCommand.levels:
                graph.surfaces.forEach((surf, index) => {
                    surfacesData.push({
                        type: "contour",
                        autocolorscale: false,
                        autocontour: false,
                        z: dataset[zValues[index]],
                        x: dataset[xValues[index]],
                        y: dataset[yValues[index]],
                        showlegend: true,
                        name: surf.title,
                        line: {
                            color: surf.color,
                        },
                        contours: {
                            coloring: "none",
                            start: surf.firstLevel,
                            end: Math.max.apply(null, dataset[zValues[index]]),
                            size: surf.levelIncrement,
                            showlabels: true,
                            labelfont: {
                                color: "black",
                            },
                        },
                    });
                });
                layout = {
                    title: this.props.printTitle && this.props.graph.title,
                    autosize: true,
                    width: width,
                    height: height,
                    margin: {
                        t: 50,
                        pad: 4,
                    },
                    dragmode: this.props.dragmode,
                    xaxis: { title: graph.axes[0].title },
                    yaxis: { title: graph.axes[1].title },
                    scene: {
                        xaxis: { showgrid: false },
                        yaxis: { showgrid: false },
                    },
                    legend: {
                        x: 1,
                        xanchor: "right",
                        y: 1,
                    },
                };
                break;
            case GraphCommand.graph3d:
                graph.surfaces.forEach((surf, index) => {
                    surfacesData.push({
                        type: "mesh3d",
                        z: dataset[zValues[index]],
                        x: dataset[xValues[index]],
                        y: dataset[yValues[index]],
                        color: surf.color,
                        showlegend: true,
                        name: surf.title,
                    });
                });
                layout = {
                    title: this.props.printTitle && this.props.graph.title,
                    autosize: false,
                    width: width,
                    height: height,
                    margin: {
                        t: 50,
                        pad: 4,
                    },
                    scene: {
                        xaxis: { title: graph.axes[0].title, showgrid: showGrid },
                        yaxis: { title: graph.axes[1].title, showgrid: showGrid },
                        zaxis: { title: graph.axes[2].title, showgrid: showGrid },
                    },
                    legend: {
                        x: 1,
                        xanchor: "right",
                        y: 1,
                    },
                };
                break;
        }
        return { surfacesData, layout };
    }
    render() {
        const { data, graph, xValues, yValues, zValues, margins } = this.props;
        const { width, height } = this.props.svgDimensions;
        const { filter } = this.state;
        const { surfacesData, layout } = this.prepareDataTraces(graph, data.data, xValues, yValues, zValues, graph.grid, height - margins.bottom, width);
        const filteredSurfaces = surfacesData.filter((element) => element.name.includes(filter));
        return (React.createElement("div", { style: {
                marginTop: margins.top,
                marginBottom: margins.bottom,
                display: "flex",
                flexDirection: "column",
                width: width,
                height: height,
                alignItems: "flex-end",
            } },
            React.createElement("div", { style: { display: "flex", gap: "10px" } },
                graph.command === GraphCommand.levels ? (React.createElement("div", { className: "position-tooltip" },
                    React.createElement("span", null,
                        React.createElement("b", null, "X:"),
                        ` ${this.state.position.x}`),
                    React.createElement("span", null,
                        React.createElement("b", null, "Y:"),
                        " ",
                        ` ${this.state.position.y}`))) : null,
                React.createElement("div", { className: "focus-filter3D" },
                    React.createElement(LegendFilter, { inputOnChange: (event) => this.setState({ filter: event.target.value }), onFilterClean: () => this.setState({ filter: "" }), removeAllLegendRows: () => this.handleHideAll(), placeholder: "Filter", value: this.state.filter }))),
            React.createElement(Plot, { data: filteredSurfaces, layout: layout, divId: "surfaces_container", config: { displayModeBar: false, scrollZoom: true }, onHover: (el) => this.updateCursorPosition(el) })));
    }
}
//# sourceMappingURL=Graph3D.js.map